import React, { Component } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import { connect } from 'react-redux'
import { compose, nest, lifecycle } from 'recompose'
import injectSagas from 'helpers/injectSagas'
import CSSModules from 'helpers/CSSModulesUtil'
import Dialog from 'react-toolbox/lib/dialog'
import CardHeader from 'components/custom/Card/CardHeader'
import Section from 'components/custom/Section/Section'
import Divider from 'components/fulcrum/divider/Divider'
import UserInput from './UserInput'
import {
  default as Collapse,
  withCollapse
} from 'components/fulcrum/collapse/Collapse'
import { Card } from 'react-toolbox/lib/card'
import { MODULE_NAME } from './constants'
import {
  TEAM_ENUM
} from './constants'

import {
  fetchEmployeeListWithImages as fetchEmployeeList,
} from 'containers/User/actions'
import {
  employeeListWithImageValues as employeeListSelector,
  isLoadingEmployeeList,
} from 'containers/User/selectors'
import Actions from './Actions'

import {
  updateProductRolesChange,
  postProductRoles,
  fetchProductRoles,
  updateEditValue
} from './actions'

import {
  pmSelector,
  paeSelector,
  spmSelector,
  aedSelector,
  productIdSelector,
  editSelector
} from './selectors'

import sagas from './sagas'

const mapStateToProps = (state) => {
  return {
    employeeList: employeeListSelector(state),
    isLoading: isLoadingEmployeeList(state),
    pmSource: pmSelector(state),
    paeSource: paeSelector(state),
    spmSource: spmSelector(state),
    aedSource: aedSelector(state),
    edit: editSelector(state),
    id: productIdSelector(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  const addRoleToUsers = role => R.map(user => ({ role, ...user }))

  return {
    fetchProductRoles: (id) => dispatch(fetchProductRoles(id)),
    onSave: (id) => dispatch(postProductRoles(id)),
    onEdit: (value) => dispatch(updateEditValue(value)),
    fetchEmployeeList: (query) => dispatch(fetchEmployeeList(query)),
    onPmChange: (team) => dispatch(updateProductRolesChange(
      addRoleToUsers(TEAM_ENUM.PRODUCT_MANAGER)(team),
      TEAM_ENUM.PRODUCT_MANAGER
    )),
    onPaeChange: (team) => dispatch(updateProductRolesChange(
      addRoleToUsers(TEAM_ENUM.PRODUCT_APPLICATIONS_ENGINEER)(team),
      TEAM_ENUM.PRODUCT_APPLICATIONS_ENGINEER
    )),
    onSpmChange: (team) => dispatch(updateProductRolesChange(
      addRoleToUsers(TEAM_ENUM.SOFTWARE_PROGRAM_MANAGER)(team),
      TEAM_ENUM.SOFTWARE_PROGRAM_MANAGER
    )),
    onAedChange: (team) => dispatch(updateProductRolesChange(
      addRoleToUsers(TEAM_ENUM.APPLICATIONS_ENGINEERING_DIRECTOR)(team),
      TEAM_ENUM.APPLICATIONS_ENGINEERING_DIRECTOR
    )),
  }

}



class ProductSupportTeam extends Component {

  onEdit = () => {
    this.props.onEdit(!this.props.edit)
  }
  
  render() {
    const {
      fetchProductRoles,
      employeeList,
      fetchEmployeeList,
      isLoading,
      onPmChange,
      onPaeChange,
      onSpmChange,
      onAedChange,
      pmSource,
      paeSource,
      spmSource,
      aedSource,
      id,
      collapse,
      toggleCollapse,
      edit,
      onEdit,
      onSave
      
    } = this.props

    return (
      <Card>
        <CardHeader title='Support Team'>
          <Actions
            collapse={collapse}
            toggleCollapse={toggleCollapse}
            edit={edit}
            onEdit={this.onEdit}
            onSave={onSave}
            id={id}
          />
        </CardHeader >
        <Collapse collapse={collapse}>
          <Divider/>
          <UserInput
            multi
            label='Product Applications Engineer'
            options={employeeList}
            onInputChange={fetchEmployeeList}
            onChange={onPaeChange}
            value={paeSource}
            isLoading={isLoading}
            edit={edit}
          />
          <UserInput
            multi
            label='Product Manager'
            options={employeeList}
            onInputChange={fetchEmployeeList}
            onChange={onPmChange}
            value={pmSource}
            isLoading={isLoading}
            edit={edit}
          />
          <UserInput
            multi
            label='Software Program Manager'
            options={employeeList}
            onInputChange={fetchEmployeeList}
            onChange={onSpmChange}
            value={spmSource}
            isLoading={isLoading}
            edit={edit}
          />
          <UserInput
            multi
            label='Applications Engineering Director'
            options={employeeList}
            onInputChange={fetchEmployeeList}
            onChange={onAedChange}
            value={aedSource}
            isLoading={isLoading}
            edit={edit}
          />
        </Collapse>
      </Card>
    )
  }
}


const withSagas = injectSagas({[MODULE_NAME]: sagas})


const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withLifecycle = lifecycle({
  componentDidMount() {
    const { id, fetchProductRoles } = this.props
    fetchProductRoles(id)
  }
})
const ProductSupportTeamCard = nest(Section, ProductSupportTeam)
const enhance = compose(
  withConnect,
  withSagas,
  withCollapse,
  withLifecycle
)
export default enhance(ProductSupportTeamCard)
